import { render, staticRenderFns } from "./QrcodeView.vue?vue&type=template&id=cbfa0696&scoped=true&"
import script from "./QrcodeView.vue?vue&type=script&lang=js&"
export * from "./QrcodeView.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeView.vue?vue&type=style&index=0&id=cbfa0696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfa0696",
  null
  
)

export default component.exports